import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EditProfileQueryData, SubmitEditProfileData } from 'globals/store/share.data';
import { ShareWrapper } from './share-wrapper.component';
import { JoiFile } from 'globals/store/files.model';
import { CustomQuestion } from 'globals/store/events.data';
import { BrandingData } from 'globals/store/publish.data';
import { Attendee, attendeeProps } from 'globals/store/attendees.data';
import { AttendeeEditProfileComponent } from './share.editAttendeeForm.component';
import { BrandingWrapperComponent } from 'src/app/components/branding/branding-wrapper.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'share-edit-attendee',
    template: `
<branding-wrapper 
  [brandingData]="brandingData" 
  [style.--sitebackground]="brandingData?.template?.sitebackground || '#ffffff'">
  <div *ngIf="loading" class="loading">Loading...</div>
  <div *ngIf="!loading && !attendee" [innerHTML]="helpers.strWithBreak(inactiveUrlMessage)" class="sorry"></div>
  <div *ngIf="submitted"  class="thanks">
    Thank you! Your details have been submitted.
  </div>
  <share-edit-attendee-form *ngIf="!!attendee && !submitted"
    [topTitle]="(attendee.name || 'Unnamed Attendee') + ' Profile in ' + (eventName || 'Unnamed Event')"
    [eventId]="eventId"
    [attendee]="attendee"
    [publishCode]="publishCode"
    [customQuestions]="customQuestions"
    [error]="error"
    [processing]="processing"
    [template]="template"
    (onSubmit)="submit()">
  </share-edit-attendee-form>
</branding-wrapper>
    `,
    styleUrls: ['./share.editPerformer.scss'],
    styles: [`
      add-assets { margin-bottom: 10px; }
      ::ng-deep add-assets .add_btn { text-align: left !important; }
    `],
    standalone: true,
    imports: [AttendeeEditProfileComponent, CommonModule, BrandingWrapperComponent],
})
export class AttendeeEditComponent extends ShareWrapper<AttendeeEditComponent> {
    publishCode:string;
    props = attendeeProps
    newFiles: JoiFile[] = []
    oldFiles: JoiFile[]
    eventId;
    eventName: string
    cannotSubmitMessage = "The attendee profile can't be submitted at this time.\nPlease reload this page and try again."
    attendee: Attendee
    inactiveUrlMessage = "The attendee profile is not currently available for editing.\n\nTo review or update your profile, please contact the event organiser and ask them to re-activate your edit profile webform."
    invalid = false
    changed = false
    CTAInvalid = false
    customQuestions: CustomQuestion[] = []
    brandingData: BrandingData

    constructor(private route:ActivatedRoute) {
      super()
      this.loading = true;
      this.route.params.subscribe(params=>{
        if(!params || !params.hasOwnProperty('publishCode')) {
          this.loading = false;
          document.title = "Unavailable";
        } else {
          this.publishCode = params.publishCode;
          const queryData: EditProfileQueryData = { publishCode:this.publishCode, entityType: 'attendee' }
          this.publicService.loadEditProfile(queryData).then(profile => {
            this.loading = false;
            if (!profile) {
              document.title = "Unavailable";
              return
            }
            // console.log(profile)
            this.loading = false;
            this.attendee = profile.entity as Attendee
            this.eventId = profile.eventId
            this.eventName = profile.eventName
            document.title = "Edit attendee "+this.attendee.name
            this.customQuestions = profile.customQuestions || []
            this.brandingData = profile.brandingData
            this.template = profile.brandingData?.template
          }).catch(e => {
            console.log(e)
            this.loading = false;
            document.title = "Unavailable";
          })
        }
        document.title = "loading";
      })
    }


    async submit(){
      this.processing = true;
      const data: SubmitEditProfileData = {
        publishCode:this.publishCode,
        entity:this.attendee,
        eventId: this.eventId,
        entityType: 'attendee'
      }
      console.log(data)
      const successfullySubmitted = await this.publicService.submitEditProfile(data)
      this.processing = false;
      if (successfullySubmitted) this.submitted = true;
      else this.showError(this.cannotSubmitMessage)
    }
}

